// Lo que baja "Descargar" de Videos cortos (ADR-2026-10-31-videos-cortos-se-descargan-todos): los videos ya salidos,
// uno por producto, con el nombre del producto (los nombres de archivo salen igual que en el Catálogo). Puro.
import { limpiar, nombreLibre } from '../catalogoAgente/fotosDelCatalogo';
import type { PlanDeVideos } from './plan';

export interface VideoDelLote {
  imageId: string;
  varianteId: string;
  /** "Silla Oslo.mp4"; dos productos con el mismo nombre no se pisan ("… (2).mp4"). */
  nombre: string;
}

/**
 * Hasta cuántos videos van en UN zip. El zip se arma en la memoria del navegador: un video pesa ~6 MB (11 MB los
 * más pesados), así que 20 son ~120 MB; un lote de 50 (~300 MB, más la copia del zip) no entra en un teléfono.
 * Con más, se bajan sueltos.
 */
export const MAX_VIDEOS_EN_ZIP = 20;

export const comoSeBajan = (cantidad: number): 'zip' | 'sueltos' => (cantidad <= MAX_VIDEOS_EN_ZIP ? 'zip' : 'sueltos');

export function videosDelLote(plan: Pick<PlanDeVideos, 'productos'>): VideoDelLote[] {
  const usados = new Set<string>();
  return plan.productos.flatMap((p) =>
    p.estado === 'listo' && p.videoId ? [{ imageId: p.videoId, varianteId: p.varianteId, nombre: `${nombreLibre(limpiar(p.nombre) || 'Video', usados)}.mp4` }] : [],
  );
}

export const nombreDelZipDeVideos = (titulo: string): string => `${limpiar(titulo) || 'videos'}.zip`;
